// extracted by mini-css-extract-plugin
export default {"inactiveItem":"Logins_inactiveItem__iO355","title":"Logins_title__wKuF+","logins":"Logins_logins__0Y5dV","subtitle":"Logins_subtitle__5VU37","inactive":"Logins_inactive__0cX65"};